import { useEnv } from "./use-env";
import { useSiteMetadata } from "./use-site-metadata";
export var usePrivacyPagePath = function () {
  var metadata = useSiteMetadata();
  var env = useEnv();
  // legacy falback
  return metadata.privacyPagePath || env.PRIVACY_PATH || '';
};